/**
 * Identifies whether the rate spread is applied to a long or short position.
 * tag: 40795
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamRateSpreadPositionType {
  /** Short */
  Short = 0,
  /** Long */
  Long = 1,
}
